export const SEOData = {
  title: "Find a Study - StudyKIK",
  description: "",
  keywords: ""
}
